import React, { useState } from "react"
import { AddedReason, Container, Label, LabelWrapper, Wrapper } from "./Reason.styled"
import Input from "../../../../Ui/Form/Input"
import PrimaryButton from "../../../../Ui/Buttons/PrimaryButton"
import { InputReason, OrderRefund } from "@lib/types/generated/graphql-types"
import { useMutation } from "@apollo/client"
import UPDATE_REFUND from "../../../../../graphql/mutations/order/refunds/UpdateRefund"
import { ReactComponent as TrashIcon } from "../../../../../images/icons/trash-can.svg"
import { Loader } from "../../../../Ui/Loader"
import { theme } from "../../../../../theme"
import { ReactComponent as DownIcon } from "images/icons/chevron-down.svg"
import { getRefundInput } from "../Helpers/helpers"
import { handleErrorMessages } from "helpers/errors"

type Props = {
  refund: OrderRefund
  refetch: () => void
}

const Reason = ({ refund, refetch }: Props) => {
  const [reason, setReason] = React.useState<InputReason>({ cause: "", code: "" })
  const [expanded, setExpanded] = useState<boolean>(false)

  const updateCause = (cause: string) => setReason({ ...reason, cause: cause })
  const updateCode = (code: string) => setReason({ ...reason, code: code })

  const [updateRefund, { loading }] = useMutation(UPDATE_REFUND, {
    onCompleted: () => refetch(),
    onError: (error) => {
      handleErrorMessages(error)
    }
  })

  const updateReason = () => {
    updateRefund({
      variables: {
        refundId: refund.id,
        input: {
          ...getRefundInput(refund),
          ...(reason.cause && reason.code && { reason: reason })
        }
      }
    })
  }

  const removeReason = () => {
    updateRefund({
      variables: {
        refundId: refund.id,
        input: {
          ...getRefundInput(refund),
          reason: null
        }
      }
    })
  }

  if (refund?.reason)
    return (
      <Wrapper>
        <Label>Reason</Label>
        <AddedReason>
          <div>
            <span>
              <b>Cause:</b> {refund?.reason.cause}
            </span>
            <span>
              <b>Code:</b> {refund?.reason.code}
            </span>
          </div>
          {loading ? (
            <Loader color={theme.colors.grey} />
          ) : (
            <TrashIcon onClick={removeReason}></TrashIcon>
          )}
        </AddedReason>
      </Wrapper>
    )

  return (
    <Wrapper>
      <LabelWrapper onClick={() => setExpanded(!expanded)}>
        <Label>Reason</Label>
        <DownIcon />
      </LabelWrapper>
      {expanded && (
        <Container addedReason={!!refund?.reason}>
          {refund?.reason ? (
            <AddedReason>
              <div>
                <span>
                  <b>Cause:</b> {refund?.reason.cause}
                </span>
                <span>
                  <b>Code:</b> {refund?.reason.code}
                </span>
              </div>
              {loading ? (
                <Loader color={theme.colors.grey} />
              ) : (
                <TrashIcon onClick={removeReason}></TrashIcon>
              )}
            </AddedReason>
          ) : (
            <>
              <Input
                name={"cause"}
                placeholder={"Cause"}
                removePaddingBottom={true}
                onChange={(e: React.FormEvent<HTMLInputElement>) =>
                  updateCause(e.currentTarget.value)
                }
              />
              <Input
                name={"code"}
                placeholder={"Code"}
                removePaddingBottom={true}
                onChange={(e: React.FormEvent<HTMLInputElement>) =>
                  updateCode(e.currentTarget.value)
                }
              />
              <PrimaryButton
                disabled={!reason.cause || !reason.code}
                loading={loading}
                handleClick={updateReason}
              >
                Add
              </PrimaryButton>
            </>
          )}
        </Container>
      )}
    </Wrapper>
  )
}

export default Reason
